import { buildGraphqlQuery } from '@ztechapps/common.utils'

export const buildQuery = (field) => buildGraphqlQuery('Customer', `_id ${field}`)
export const buildOrderQuery = (field) => buildGraphqlQuery('Order', `_id ${field}`)
export const communicationFragment = `
 communication {
    _id
    email {
      _id
      to
      from
      timeStamp
      content
    }
  }
`
export const productFragment = `
 product {
      _id
      code
      name
      coverImage
      status
      inventory {
        _id
        quantityOnHand
      }
    }
`

export const paymentFragment = `payment {
    _id
    status
    date
    method
    remarks
    stripeInfo {
      _id
      paymentIntent
      paymentId
    }
  }`

export const shippingFragment = `shipping {
    _id
    status
    shipmentId
    amount
    shippingCost
    insuranceCost
    date
    trackingNumber
    trackingUrl
    pdfLabel
    pngLabel
    zplLabel
    pickupId
    pickupWindowStartDate
    pickupWindowEndDate
    pickupNotes
    pickupCancelledDate
    isVoidLabel
    voidMessage
    rate {
      _id
      deliveryDays
      estimatedDeliveryDate
      serviceType
      carrierName
    }
    labelId
    billToCustomer
    billToAccount
    billToPostalCode
    billToCountryCode
  }`

export const shippingAddressFragment = `shippingAddress{
      _id
      street1
      street2
      city
      state
      zip
      country
      fullAddress
    }`

export const billingAddressFragment = `billingAddress{
      _id
      street1
      street2
      city
      state
      zip
      country
      fullAddress
    }`

export const customerFragment = `_id
    profile {
      _id
      name
      picture
      email
    }
    status
    company {
      _id
      name
    }
    address {
        _id
       street1
       street2
       city
       state
       zip
       fullAddress
       country
    }
    addresses {
        _id
       street1
       street2
       city
       state
       zip
       fullAddress
       country
       status
    }`

export const orderFragment = `_id
  summary
  code
  status
  updatedAt
  createdAt
  net
  by {
    ${customerFragment}
  }
  items {
    _id
    ${productFragment}
    quantity
    price
    net
    remarks
    tags
  }
  shippingFee
  gross
  remarks
  tags
  taxAmount
  discount
  ${paymentFragment}
  ${communicationFragment}
  ${shippingFragment}
  ${shippingAddressFragment}
  ${billingAddressFragment}
  customerPoNumber
  allItemsInStock
`

export const queries = buildGraphqlQuery('Order', orderFragment)

export const customerQueries = buildGraphqlQuery(
  'Customer',
  `
     ${customerFragment}
  `,
  ['addresses']
)
